import React from 'react'
import useForm from 'react-hook-form'
import useSnackbar from 'hooks/useSnackbar'

import {
  Button,
  Dialog,
  Divider,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Typography,
} from '@material-ui/core'
import { KeyboardDatePicker } from '@material-ui/pickers'

import schemas from '../../schemas'
import * as service from 'service'
import moment from 'moment'

const DialogInvoiceChangeDueDate = ({
  open,
  setOpen,
  invoiceId,
  onLoading = () => {},
  onEvent = () => {},
}) => {
  const { handleSubmit, register, watch, setValue, errors } = useForm({
    validationSchema: schemas.newDateSchema,
  })

  React.useEffect(() => {
    register({ name: 'corpDueDate' })
  }, [register])

  const snackbar = useSnackbar()

  const onSubmit = async params => {
    onLoading(true)
    onEvent(false)
    try {
      await service.recurrence.invoices.changeDueDate({
        invoiceId,
        params,
      })

      snackbar.open({
        message: 'Alteração da data de vencimento realizada com sucesso!',
        variant: 'success',
      })

      onEvent(true)
      setOpen(false)
      onLoading(false)
    } catch {
      snackbar.open({
        message: 'Falha ao alterar data de vencimento da fatura!',
        variant: 'error',
      })
      onLoading(false)
    }
  }

  const values = watch()

  return (
    <Dialog open={open} onClose={() => setOpen(false)}>
      <DialogTitle id="form-dialog-title">
        <div>
          <Typography variant="h3">Alterar data de vencimento</Typography>
        </div>
      </DialogTitle>
      <DialogContent>
        <DialogContentText align="justify">
          Atenção: Ao confirmar está ação a data de vencimento da fatura será
          alterada.
        </DialogContentText>
        <form id="change-due-date-form" onSubmit={handleSubmit(onSubmit)}>
          <KeyboardDatePicker
            margin="dense"
            disablePast
            placeholder="Nova data de vencimento"
            format="dd/MM/yyyy"
            name="corpDueDate"
            fullWidth
            error={errors.corpDueDate !== undefined}
            helperText={errors.corpDueDate ? errors.corpDueDate.message : ''}
            onChange={e =>
              setValue(
                'corpDueDate',
                moment(e)
                  .utc(false)
                  .format(),
              )
            }
            value={values.corpDueDate || null}
          ></KeyboardDatePicker>
        </form>
      </DialogContent>
      <Divider />
      <DialogActions p={2}>
        <Button
          variant="contained"
          color="primary"
          form="change-due-date-form"
          type="submit"
        >
          Confirmar
        </Button>
        <Button
          onClick={() => setOpen(false)}
          variant="outlined"
          color="primary"
        >
          Cancelar
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default DialogInvoiceChangeDueDate
